/*
  Adds the armed add-on product to the cart once the main product has been added.

  Deliberately decoupled from Dawn's own form: it subscribes to Dawn's cart-update event
  rather than injecting items[] into the product form, so a failure here can never break
  the primary add-to-cart path. Dormant until custom.addon_product exists.

  Untested against a live add-on SKU — there is no add-on product in the catalogue yet.
*/
if (!customElements.get('shintop-addon')) {
  customElements.define(
    'shintop-addon',
    class ShintopAddon extends HTMLElement {
      connectedCallback() {
        this.input = this.querySelector('.shintop-addon__input');
        if (!this.input || typeof subscribe !== 'function') return;

        const eventName =
          typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate
            ? PUB_SUB_EVENTS.cartUpdate
            : 'cart-update';

        this.unsubscribe = subscribe(eventName, (payload) => {
          // Only react to an add originating from this product's form, and only once.
          if (payload?.source !== 'product-form') return;
          if (!this.input.checked || this.pending) return;
          this.addAddon();
        });
      }

      disconnectedCallback() {
        this.unsubscribe?.();
      }

      async addAddon() {
        this.pending = true;
        this.input.checked = false;

        try {
          const body = new FormData();
          body.append('items[0][id]', this.dataset.variantId);
          body.append('items[0][quantity]', '1');
          const helper = window.shintopCart;
          if (helper) {
            body.append('sections', helper.sections().join(','));
            body.append('sections_url', window.location.pathname);
          }

          const response = await fetch(`${window.routes.cart_add_url}.js`, {
            method: 'POST',
            headers: { Accept: 'application/json' },
            body,
          });

          if (!response.ok) throw new Error(`cart/add returned ${response.status}`);

          /*
            THE BUBBLE STAYED ONE BEHIND (audit 2026-10-14, C-d, latent while no add-on is armed).
            The publish made Dawn re-render the drawer's lines and totals, and nothing repainted
            the header count — the main item's add had painted it a moment earlier, without this
            one. The cart's sections now ride in this request and the response goes to the
            shared after-write step (assets/shintop-cart.js), which renders the drawer and the
            bubble from them and publishes the whole cart. No `open`: the buy box's own add has
            already opened the drawer, and this lands inside it.

            (Before that, the two events this fired — `shintop:refresh`, `shintop:addon-added` —
            had no listeners anywhere in the theme, so a successful add-on painted nothing at all.)
          */
          const parsed = await response.json();
          if (helper) {
            helper.afterCartWrite(parsed, { source: 'shintop-addon' });
          } else if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            const cart = await fetch(`${window.routes.cart_url}.js`)
              .then((r) => (r.ok ? r.json() : null))
              .catch(() => null);
            if (cart) publish(PUB_SUB_EVENTS.cartUpdate, { source: 'shintop-addon', cartData: cart });
          }
        } catch (error) {
          // Never surface a failed $1 upsell as a blocking error — the main item is in the
          // cart, which is what matters.
          console.warn('[shintop] add-on could not be added:', error);
        } finally {
          this.pending = false;
        }
      }
    },
  );
}
